import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import messages from './filterMessages';

class NumberFilter extends Component {
  state = {
    greater: null,
    lesser: null,
  };

  componentDidMount() {
    const { initialValue } = this.props;
    if (initialValue) {
      this.setState({
        greater: initialValue.greater ?? null,
        lesser: initialValue.lesser ?? null,
      });
    }
  }

  handleGreaterChange(e) {
    const value = e.target.value === '' ? null : Number(e.target.value);
    this.setState({ greater: value }, () => {
      if (this.props.hideFilterButton) {
        this.props.onFilter({ greater: this.state.greater, lesser: this.state.lesser });
      }
    });
  }

  handleLesserChange(e) {
    const value = e.target.value === '' ? null : Number(e.target.value);
    this.setState({ lesser: value }, () => {
      if (this.props.hideFilterButton) {
        this.props.onFilter({ greater: this.state.greater, lesser: this.state.lesser });
      }
    });
  }

  handleKeyUp(e) {
    if (e.key === 'Enter') {
      this.applyFilter();
    } else if (e.key === 'Escape') {
      this.clearFilter();
    }
  }

  applyFilter() {
    const { greater, lesser } = this.state;
    this.props.onFilter({ greater, lesser });
  }

  clearFilter() {
    this.setState({ greater: null, lesser: null }, () => {
      this.props.onFilter({ greater: null, lesser: null });
    });
  }

  render() {
    const { greater, lesser } = this.state;
    const { isFiltered, intl, hideFilterButton } = this.props;

    return (
      <div>
        {!hideFilterButton && (
          <>
            <button
              type="button"
              className="btn btn-inverse btn-block btn-sm margin10B"
              onClick={() => this.applyFilter()}
            >
              {intl.formatMessage(messages.Filter)}
            </button>
            {isFiltered && (
              <button
                type="button"
                className="btn btn-default btn-sm margin10B"
                onClick={() => this.clearFilter()}
              >
                <i className="fa fa-times" />
                &nbsp;
                <span>{intl.formatMessage(messages.ClearFilter)}</span>
              </button>
            )}
          </>
        )}
        <div className="input-group" title={intl.formatMessage(messages.GreaterOrEqualThan)}>
          <label className="input-group-addon">&ge;</label>
          <input
            type="number"
            step="any"
            className="form-control"
            value={greater ?? ''}
            onChange={e => this.handleGreaterChange(e)}
            onKeyUp={e => this.handleKeyUp(e)}
            placeholder={intl.formatMessage(messages.Number)}
            autoFocus
          />
        </div>
        <div className="input-group margin10T" title={intl.formatMessage(messages.LesserOrEqualThan)}>
          <label className="input-group-addon">&le;</label>
          <input
            type="number"
            step="any"
            className="form-control"
            value={lesser ?? ''}
            onChange={e => this.handleLesserChange(e)}
            onKeyUp={e => this.handleKeyUp(e)}
            placeholder={intl.formatMessage(messages.Number)}
          />
        </div>
      </div>
    );
  }

  static propTypes = {
    initialValue: PropTypes.shape({
      greater: PropTypes.number,
      lesser: PropTypes.number,
    }),
    onFilter: PropTypes.func.isRequired,
    isFiltered: PropTypes.bool,
    intl: intlShape.isRequired,
    hideFilterButton: PropTypes.bool,
  };

  static defaultProps = {
    initialValue: null,
    isFiltered: false,
    hideFilterButton: false,
  };
}

export default NumberFilter;
